import { useAuthUser } from './useAuthUser';

export function usePermission() {
  const { currentUser } = useAuthUser();

  /**
   * Check if user has a specific permission
   *
   * @param {string} permissionType - Permission type (e.g., 'VIEW')
   * @returns {boolean}
   */
  function hasPermission(permissionType) {
    if (!currentUser.value || !currentUser.value.permissions) {
      return false;
    }

    return currentUser.value.permissions.some(
      permission => permission.permissionType === permissionType
    );
  }

  /**
   * Check if user has view permission
   *
   * @returns {boolean}
   */
  function hasExportPermission() {
    return hasPermission('VIEW');
  }

  /**
   * Check if user has edit permission (for import functionality)
   *
   * @returns {boolean}
   */
  function hasImportPermission() {
    return hasPermission('EDIT');
  }

  /**
   * Check if user has edit permission (for master data management)
   *
   * @returns {boolean}
   */
  function hasEditPermission() {
    return hasPermission('EDIT');
  }

  /**
   * Check if user can view the detail pages (accommodations, event detail)
   *
   * @returns {boolean}
   */
  function hasDetailPermission() {
    return hasPermission('DETAIL');
  }

  return {
    hasPermission,
    hasExportPermission,
    hasImportPermission,
    hasEditPermission,
    hasDetailPermission,
  };
}
